import { render, staticRenderFns } from "./huicaiyunProduct.vue?vue&type=template&id=4cf99c84&scoped=true"
import script from "./huicaiyunProduct.vue?vue&type=script&lang=js"
export * from "./huicaiyunProduct.vue?vue&type=script&lang=js"
import style0 from "./huicaiyunProduct.vue?vue&type=style&index=0&id=4cf99c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf99c84",
  null
  
)

export default component.exports